import * as React from 'react';
import PropTypes from 'prop-types';

import POI from '../classes/POI';
import RoutingService from '../services/Routing';

/**
 * A React component for displaying a POI detail overlay, using https://bulma.io/documentation/components/modal/
 * 
 * @param {any} props 
 * @returns {React.Component}
 */
function POIDetail(props) {
  const { selectedPOI,
          setSelectedPOI,
          setDestination,
        } = props;

  return (
    <div className="modal is-active">
        <div className="modal-background" onClick={() => setSelectedPOI(null)}></div>
        <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title">
                    Title: { selectedPOI.title }
                    <br />
                    Category: { selectedPOI.category }
                </p>
                <button className="delete" aria-label="close" onClick={() => setSelectedPOI(null)}></button>
            </header>
            <section className="modal-card-body">
                <div className="content">
                    { selectedPOI.description }
                </div>
            </section>
            <footer className="modal-card-foot">
                <button 
                    className="button is-success" 
                    onClick={() => {
                        setDestination(RoutingService.GetWaypointNearestPosition(selectedPOI.centerPosition, selectedPOI.map));
                        setSelectedPOI(null);
                    }}
                >
                    Start Routing
                </button>
                <button className="button" onClick={() => setSelectedPOI(null)}>Close</button>
            </footer>
        </div>
    </div>
  );
}

POIDetail.propTypes = {
  selectedPOI: PropTypes.instanceOf(POI),
  setSelectedPOI: PropTypes.func.isRequired,
  setDestination: PropTypes.func.isRequired,
}

export default POIDetail;



// WEBPACK FOOTER //
// ./src/components/POIDetail.js